/**
 * Phase 16c.3: Turkish case endings after a clock time, as it is read aloud ("14:32’den sonra", "14:32’ye kadar",
 * "14:40’tan", "15:00’e"). The ending follows the last number word: its last vowel (front or back) and its last
 * sound (a hard consonant gives t-, a vowel a y- buffer in the dative).
 */
type Case = 'ablative' | 'dative';

/** a number word's ending: [ablative, dative] */
const ONES: Record<number, [string, string]> = {
  0: ['dan', 'a'], // sıfır
  1: ['den', 'e'], // bir
  2: ['den', 'ye'], // iki
  3: ['ten', 'e'], // üç
  4: ['ten', 'e'], // dört
  5: ['ten', 'e'], // beş
  6: ['dan', 'ya'], // altı
  7: ['den', 'ye'], // yedi
  8: ['den', 'e'], // sekiz
  9: ['dan', 'a'], // dokuz
};
const TENS: Record<number, [string, string]> = {
  1: ['dan', 'a'], // on
  2: ['den', 'ye'], // yirmi
  3: ['dan', 'a'], // otuz
  4: ['tan', 'a'], // kırk
  5: ['den', 'ye'], // elli
};

/** the ending of a number read aloud (0…59) */
function numberEnding(value: number, which: Case): string {
  const pick = (pair: [string, string]) => (which === 'ablative' ? pair[0] : pair[1]);
  if (value === 0) return pick(ONES[0] as [string, string]);
  const ones = value % 10;
  if (ones !== 0) return pick(ONES[ones] as [string, string]);
  return pick(TENS[Math.floor(value / 10)] as [string, string]);
}

/** "’den", "’ye"… for a time written HH:MM (minutes :00 read as the hour: "15:00" → "on beş" → "’ten") */
export function timeSuffix(time: string, which: Case): string {
  const match = /^(\d{1,2})[:.](\d{2})$/.exec(time.trim());
  if (!match) return which === 'ablative' ? '’den' : '’e';
  const [hours, minutes] = [Number(match[1]), Number(match[2])];
  return `’${numberEnding(minutes === 0 ? hours : minutes, which)}`;
}
